export const playMeetingReminderSound = () => {
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;

    const audioContext = new AudioContext();
    const gain = audioContext.createGain();
    gain.gain.setValueAtTime(0.0001, audioContext.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.08, audioContext.currentTime + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, audioContext.currentTime + 0.55);
    gain.connect(audioContext.destination);

    const playTone = (frequency, startTime, duration) => {
      const oscillator = audioContext.createOscillator();
      oscillator.type = "sine";
      oscillator.frequency.setValueAtTime(frequency, startTime);
      oscillator.connect(gain);
      oscillator.start(startTime);
      oscillator.stop(startTime + duration);
    };

    const startTime = audioContext.currentTime + 0.02;
    playTone(880, startTime, 0.12);
    playTone(1174.66, startTime + 0.16, 0.16);

    window.setTimeout(() => {
      audioContext.close().catch(() => {});
    }, 700);
  } catch (_error) {
    // Browsers can block notification sounds until the user interacts.
  }
};
